// extracted by mini-css-extract-plugin
module.exports = {"box":"Box_box__nNoWg","titleRow":"Box_titleRow__3yyic","actions":"Box_actions__1CiFs","children":"Box_children__1P2_p","childPadding":"Box_childPadding__1YGuY"};